export const circleVertexShader = `#version 300 es

in vec2 a_position;
in vec2 a_texCoord;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

out vec2 v_texCoord;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);
    
    v_texCoord = a_texCoord;
}
`;

export const circleFragmentShader = `#version 300 es

precision highp float;

in vec2 v_texCoord;

uniform float u_opacity;
uniform vec4 u_color;

float sdCircle(in vec2 p, in float r) {
  return length(p) - r;
}

out vec4 outColor;

void main() {
  vec2 uv = v_texCoord * 2.0 - 1.0;
  float d = sdCircle(uv, 1.0);
  
  vec4 transparentColor = vec4(0, 0, 0, 0);
  vec4 color = mix(transparentColor, u_color, 1.0 - smoothstep(0.0, 0.01, d));
  
  outColor = color;
}
`;
